import TeamStatistics from 'components/general/TeamStatistics'

function Ru7TeamStats({ data }) {

  const stats = [
    { code: 'RC'},
    { code: 'YC'},
    { code: 'DROP' },
    { code: 'PTY' },
    { code: 'CONV' , component:'type7'},
    { code: 'PTRY' },
    { code: 'TRY' },
    { code: 'PTS' }
  ]

  return (<>
    <TeamStatistics data={data?.results} stats={stats} />
  </>);
}


export default Ru7TeamStats;